export default {
    it: {
        "base_label": "Data",
        "birthday": "Data di nascita",
        "date-error": "Scegli una data",
        "date-ok": "",
        "data_bonifico": "Data pagamento",
        "data_pagamento": "Data pagamento",
        
    },
    en: {
        "base_label": "Date",
        "date-error": "Choose a date",
        "date-ok": "",
        "birthday": "Birthday",
        "data_bonifico": "Payment date",
        "data_pagamento": "Payment date",

    }
}